import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Documento',
        path: '/biblioteca/bibdocumento',
        name: 'bibdocumento',
        component: () => import('@/views/biblioteca/bibdocumento/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_CATALOGACAONOVO_MENU_1300100199],
        },
        goesToMenu: true,
    },
    {
        description: 'Pesquisa Documento por Palavra Chave',
        path: '/biblioteca/bibdocumentopesquisapalavrachave',
        name: 'bibdocumentopesquisapalavrachave',
        component: () => import('@/views/biblioteca/bibdocumento/IndexPesquisaPalavraChave.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_CATALOGACAONOVO_MENU_1300100199],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Documento',
        path: '/biblioteca/bibdocumento/cadastro/:id?',
        parent: 'bibdocumento',
        name: 'bibdocumento_create',
        component: () => import('@/views/biblioteca/bibdocumento/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_CATALOGACAONOVO_MENU_1300100199],
        },
        goesToMenu: true,
    },
    {
        description: 'Áreas de Interesse',
        path: '/biblioteca/bibdocumento/areainteresse/:id?',
        parent: 'bibdocumento',
        name: 'bibdocumento_areainteresse',
        component: () => import('@/views/biblioteca/bibdocumento/BibDocumentoAreaInteresse.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_CATALOGACAONOVO_MENU_1300100199],
        },
        goesToMenu: true,
    },
    {
        description: 'Autoria',
        path: '/biblioteca/bibdocumento/autoria/:id?',
        parent: 'bibdocumento',
        name: 'bibdocumento_autoria',
        component: () => import('@/views/biblioteca/bibdocumento/BibDocumentoAutor.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_CATALOGACAONOVO_MENU_1300100199],
        },
        goesToMenu: true,
    },
    {
        description: 'Palavra Chave',
        path: '/biblioteca/bibdocumento/palavrachave/:id?',
        parent: 'bibdocumento',
        name: 'bibdocumento_palavrachave',
        component: () => import('@/views/biblioteca/bibdocumento/BibDocumentoPalavraChave.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_PESQUISAPALAVRACHAVENOVO_MENU_1300200299],
        },
        goesToMenu: true,
    },
]
